import { ClerkProvider } from '@clerk/clerk-react';
import React from 'react';
import { clerkAppearance } from './clerk-appearance';

interface RedbaxAuthProviderProps {
  children: React.ReactNode;
  publishableKey?: string;
}

export function RedbaxAuthProvider({
  children,
  publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '',
}: RedbaxAuthProviderProps) {
  return (
    <ClerkProvider publishableKey={publishableKey} appearance={clerkAppearance}>
      {children}
    </ClerkProvider>
  );
}
